import type { PuzzleResult } from './PuzzleGenerator';

export function generateSignalFlow(complexity: number, subtlety: number): PuzzleResult {
  const nodeCount = Math.min(complexity, 8);

  // Generate a path order (sequence of node indices)
  const reference: number[][] = [];
  const nodes = Array.from({ length: nodeCount }, (_, i) => i);

  // Shuffle to create a path
  for (let i = nodes.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [nodes[i], nodes[j]] = [nodes[j], nodes[i]];
  }

  for (const node of nodes) {
    reference.push([node]);
  }

  const hasError = Math.random() < 0.75;
  let output: number[][];

  if (hasError) {
    output = reference.map(r => [...r]);
    if (subtlety < 0.3) {
      // Easy: reverse two distant nodes
      const a = 0;
      const b = output.length - 1;
      [output[a], output[b]] = [output[b], output[a]];
    } else {
      // Medium/Hard: swap two adjacent nodes
      const pos = Math.floor(Math.random() * (output.length - 1));
      [output[pos], output[pos + 1]] = [output[pos + 1], output[pos]];
    }
  } else {
    output = reference.map(r => [...r]);
  }

  return {
    reference,
    output,
    hasError,
    referenceLabel: 'Correct Path',
    outputLabel: 'Agent Path',
  };
}
